import axios from '../../marketplace/axios-marketplace';

const solicitarCotacao = data => axios.post('/cotacoes', data);

export default {
  solicitarCotacao,
};
